import { UserRoles } from '@/enums';
import { Leads } from '@/modules/leads/types';

const access_roles = {
  [Leads.Pages.LEADS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
    UserRoles.Internal.PURCHASING_MANAGER,
  ],
  [Leads.Pages.LEAD_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
    UserRoles.Internal.PURCHASING_MANAGER,
  ],
};

export default access_roles;
